import { defineCommand, defineScope } from '@dataroom/interaction';
import { defineAppCommands } from '../../extensions/commands';
import { t } from '../../lib/i18n';
import { toggleLayer } from '../../shell/overlays';
export const copilotScope = defineScope<{ available: () => boolean; limited: () => boolean }>({
  id: 'copilot',
  kind: 'global',
  title: () => t('aiClient.scope.run'),
});
export default defineAppCommands({
  id: 'copilot',
  scopes: [copilotScope],
  commands: [
    defineCommand({
      id: 'ai.ask',
      scope: copilotScope,
      title: () => t('aiClient.ask.label'),
      icon: 'sparkle',
      shortcut: 'mod+j',
      textSafe: true,
      when: (ctx) => ctx.available() || ctx.limited(),
      // Over budget the panel still opens (history stays readable) and explains the budget in a banner.
      run: () => toggleLayer('copilot', {}),
    }),
  ],
});
